import IconAccount from '@/assets/images/svg/sidebar/account.svg';
import IconLobby from '@/assets/images/svg/sidebar/lobby.svg';
import IconPromo from '@/assets/images/svg/sidebar/promo.svg';
import IconPvp from '@/assets/images/svg/sidebar/pvp.svg';
import IconFastplay from '@/assets/images/svg/sidebar/fastplay.svg';
import IconCAF from '@/assets/images/svg/sidebar/caf.svg';
import IconRAF from '@/assets/images/svg/sidebar/raf.svg';
import IconMines from '@/assets/images/svg/sidebar/mines.svg';
import IconPlinko from '@/assets/images/svg/sidebar/plinko.svg';
import IconMaxBlast from '@/assets/images/svg/sidebar/maxblast.svg';
import IconSectorX from '@/assets/images/svg/sidebar/sectorx.svg';
import IconMissionAmazon from '@/assets/images/svg/sidebar/mission-amazon.svg';
import IconDragonStone from '@/assets/images/svg/sidebar/dragonstone.svg';
import IconLiveChat from '@/assets/images/svg/sidebar/live-chat.svg';
import IconLogout from '@/assets/images/svg/sidebar/logout.svg';
import IconFishTableGames from '@/assets/images/svg/sidebar/ftg.svg';

export default {
  IconAccount,
  IconLobby,
  IconPromo,
  IconPvp,
  IconFastplay,
  IconCAF,
  IconRAF,
  IconMines,
  IconPlinko,
  IconMaxBlast,
  IconSectorX,
  IconMissionAmazon,
  IconDragonStone,
  IconLiveChat,
  IconLogout,
  IconFishTableGames,
};
